import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Endpoints} from "../../customs/endpoints";
import {CommonResponse} from "../../customs/_models/Response";
import {Observable, catchError, of} from "rxjs";
import {OT_DTO} from "../../customs/_models/OT_DTO";
import {AnalyseDTO} from "../../customs/_models/analyse.dtos";
import {DialogService} from "../../customs/_modal/dialog.service";
import {SampleDTO} from "../../customs/_models/sampleDTO";
import { AccDTO } from '../../customs/_models/AccDTO';

@Injectable({
    providedIn: 'root'
})
export class AccreditationService {

    constructor(private http: HttpClient,
                private endPoint: Endpoints,
                private dialogService: DialogService,) {
    }


    createAcc(acc: AccDTO): Observable<CommonResponse> {
        return this.http.post<CommonResponse>(`${this.endPoint.acc_endpoint}`, acc);
      }

    findAll(): Observable<AccDTO[]> {
        return this.http.get<AccDTO[]>(this.endPoint.acc_endpoint);
      }


    update(id:number,acc: AccDTO): Observable<CommonResponse> {
        return this.http.put<CommonResponse>(`${this.endPoint.acc_endpoint}/${id}`, acc)
    }


    delete(id: number) :Observable<CommonResponse>{
        return this.http.delete<CommonResponse>(`${this.endPoint.acc_endpoint}/${id}`)
    }

}
